export { default } from './MenuPromotionSmallProductCard'
